import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import classNames from 'classnames';

const Logo = () => {
  return (
    <svg
      viewBox="0 0 125 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="lg:block h-6 sm:h-8 w-auto text-violet-500 sm:ml-0 hover:text-violet-200 focus:text-violet-200 transition"
    >
      <path
        d="M28.7166 1.38024C23.6929 11.3858 24.1962 19.7581 29.0516 29.2604C29.2615 29.6788 29.0933 29.9721 28.6332 29.9721H18.5085C18.3605 29.9866 18.2121 29.9484 18.0896 29.8643C17.967 29.7801 17.8781 29.6554 17.8385 29.512C16.0741 24.8651 14.9857 20.3864 14.9857 15.9047C14.9857 15.528 14.7772 15.3196 14.4005 15.3196H10.9671C9.58533 15.3196 9.12525 15.7797 9.12525 17.1614C9.12525 20.4683 9.50195 24.947 10.8003 29.3006C10.9254 29.7205 10.7154 29.9706 10.297 29.9706H0.627935C0.251236 29.9706 0.0412991 29.7622 0.0412991 29.3855L-0.00634766 1.25517C-0.00634766 0.836779 0.20359 0.66853 0.5788 0.66853H10.9194C11.3378 0.66853 11.5477 0.920158 11.4212 1.33855C10.3789 4.8554 9.57937 9.04077 9.41261 11.0166C9.28754 12.44 9.7104 13.0251 11.0504 13.0251H14.609C14.7639 13.0343 14.9162 12.9826 15.0335 12.8811C15.1509 12.7796 15.224 12.6363 15.2373 12.4817C15.6557 9.04822 16.6607 4.94622 18.0841 1.13754C18.1237 0.994111 18.2126 0.869217 18.3351 0.784804C18.4577 0.700392 18.606 0.661858 18.7541 0.675975H28.2982C28.7166 0.66853 28.9265 0.961848 28.7166 1.38024ZM60.532 14.316C60.532 23.2749 54.7966 30.7672 43.9543 30.7672C42.0634 30.7792 40.1889 30.4164 38.4391 29.6996C36.6893 28.9829 35.0989 27.9264 33.7598 26.5914C32.4207 25.2563 31.3595 23.6691 30.6375 21.9214C29.9155 20.1738 29.547 18.3004 29.5533 16.4095C29.5533 7.49229 35.2887 0 46.1311 0C54.0849 0 60.532 6.36219 60.532 14.316ZM49.1878 15.3211C46.4661 7.49229 43.1592 3.09995 40.8573 3.09995C38.5554 3.09995 38.1355 7.49527 40.8573 15.3241C43.6192 23.2749 46.9693 27.6673 49.3129 27.6673C51.5731 27.6673 51.9572 23.2749 49.1878 15.3211ZM102.73 1.08841C102.73 9.96242 99.9662 18.083 94.1892 28.4653C93.5609 29.5954 93.0174 29.9721 92.3474 29.9721H84.3935C84.2734 29.975 84.1563 29.9342 84.064 29.8573C83.9717 29.7803 83.9105 29.6724 83.8918 29.5537C83.3885 23.4834 83.0952 18.8335 81.84 13.7294C81.6733 13.0177 81.3383 13.0177 81.1283 13.6877C78.9515 20.8048 77.2348 24.5718 74.8495 28.4653C74.2629 29.4287 73.3829 29.9721 72.6295 29.9721H61.9092C61.406 29.9721 61.1975 29.5537 61.4492 29.1353C66.4713 20.0931 65.8445 10.5074 60.9459 1.17179C60.7791 0.874002 60.9042 0.66853 61.2809 0.66853H71.8717C71.9756 0.661807 72.0786 0.691608 72.1629 0.752779C72.2471 0.813951 72.3074 0.902649 72.3332 1.00354C74.7155 8.204 75.1369 15.9479 73.7135 24.0283C73.5884 24.74 74.0916 24.9068 74.4267 24.1951C79.1912 14.0227 80.7055 8.28738 78.6537 1.1301C78.5703 0.832313 78.7788 0.66853 79.1138 0.66853H88.1144C88.2274 0.667812 88.3385 0.698826 88.4348 0.758046C88.5311 0.817266 88.6089 0.902318 88.6593 1.00354C91.5061 7.95237 92.5946 14.9861 93.473 24.07C93.5564 24.8651 94.1013 24.8234 94.3947 24.1534C96.8633 18.5029 97.5333 11.2176 94.7297 1.8835C94.4781 1.04523 94.8548 0.66853 95.8181 0.66853H102.18C102.478 0.66853 102.73 0.79509 102.73 1.08841ZM111.31 27.7953C117.591 27.0836 120.988 24.74 123.828 16.1995C124.036 15.5727 125 15.5727 125 16.2412V29.4704C125.002 29.537 124.991 29.6034 124.967 29.6656C124.943 29.7277 124.906 29.7841 124.859 29.8312C124.812 29.8784 124.755 29.9152 124.693 29.9395C124.631 29.9637 124.564 29.9749 124.498 29.9721H100.93C100.51 29.9721 100.26 29.5954 100.51 29.052C105.618 17.9997 107.954 9.96242 107.954 1.17179C107.948 1.10415 107.957 1.03599 107.98 0.972125C108.003 0.90826 108.04 0.850261 108.088 0.802237C108.136 0.754213 108.194 0.717341 108.258 0.694234C108.322 0.671128 108.39 0.662352 108.458 0.66853H117.415C117.75 0.66853 117.918 0.878469 117.918 1.25517C117.918 11.5526 115.657 18.8379 110.968 27.2519C110.77 27.6286 110.934 27.837 111.31 27.7953Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Navigation = ({
  className,
  options,
}: {
  className?: string;
  options?: any;
}) => {
  const router = useRouter();
  const [isLoginOnly, setIsLoginOnly] = useState<boolean>(false);

  useEffect(() => {
    const loginOnly = router.query.login_only;
    if (typeof loginOnly === 'string') {
      if (loginOnly === 'true') {
        setIsLoginOnly(true);
      }
    }
  }, [router]);

  const hideLinkPaths = [
    '/publisher/terms-conditions',
    '/publisher/terms-conditions-nonadmin',
  ];

  return (
    <div className={className}>
      <div className={'max-w-[1500px] mx-auto sm:px-6 lg:px-12 md:px-28 px-4'}>
        <div
          className={classNames('md:h-20 h-14 flex flex-row', {
            'sm:justify-between justify-center sm:mt-0 mt-3': isLoginOnly,
            'justify-between': !isLoginOnly,
          })}
        >
          <div className="justify-start my-auto z-20">
            {isLoginOnly ? (
              <Logo />
            ) : (
              <Link
                href={'https://planethowl.com'}
                className={'cursor-pointer'}
              >
                <Logo />
              </Link>
            )}
          </div>
          {!hideLinkPaths.includes(router.pathname) && !isLoginOnly && (
            <div className={'flex flex-row ml-4 my-auto select-none z-20'}>
              {options}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
